import React, { useEffect, useState } from 'react';
import CardContent from '@material-ui/core/CardContent';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import DescriptionIcon from '@material-ui/icons/Description';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Engineer } from '../../models/engineer';
import useResumeAttachment from './useResumeAttachment';
import { Maybe } from '../../types';

const useStyles = makeStyles(() => ({
  title: {
    marginBottom: 10,
  },
  item: {
    display: 'block',
    padding: '10px 0',
  },
  icon: {
    verticalAlign: 'middle',
    color: 'inherit',
  },
}));

export default function ResumeContentCard({ engineer } : { engineer: Engineer }) {
  const classes = useStyles();
  const [cvUrl, setCvUrl] = useState<Maybe<string>>(null);
  const { getDownloadUrl } = useResumeAttachment(engineer);
  useEffect(() => {
    getDownloadUrl().then(setCvUrl);
  }, [getDownloadUrl]);
  return (
    <CardContent>
      <Typography variant="h5" className={classes.title}>
        <AccountBoxIcon className={classes.icon} fontSize="inherit" />
        {' '}
        Resume
      </Typography>
      {engineer.linkedIn && (
        <Link href={engineer.linkedIn} target="_blank" className={classes.item}>
          <Typography>
            <LinkedInIcon className={classes.icon} fontSize="medium" />
            {' '}
            {engineer.linkedIn}
          </Typography>
        </Link>
      )}
      {cvUrl && (
        <Link href={cvUrl} className={classes.item}>
          <Typography>
            <DescriptionIcon className={classes.icon} />
            {' '}
            Download
          </Typography>
        </Link>
      )}
    </CardContent>
  );
}
